import { render } from "./AddStock.vue?vue&type=template&id=4b93f431&scoped=true"
import script from "./AddStock.vue?vue&type=script&lang=js"
export * from "./AddStock.vue?vue&type=script&lang=js"

import "./AddStock.vue?vue&type=style&index=0&id=4b93f431&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b93f431"]])

export default __exports__